import { ref } from 'vue';

const _visible = ref(false);
const _fieldsHeaders = ref<string[]>([]);
const _fieldsNames = ref<string[]>([]);
const _values = ref<{}[]>([]);
const _title = ref<string>('Opções');

let localResolve: (value: number | PromiseLike<number>) => void;

export const useFuncSelecionaOpcao = () => 
{    

    const funcSelecionaOpcao = (titulo: string, fieldsHeaders: string[], fieldsNames: string[],values: {}[] ): Promise<any> => 
    {
        
        _fieldsHeaders.value = fieldsHeaders;
        _fieldsNames.value = fieldsNames;
        _values.value = values;
        _visible.value = true;
        _title.value = titulo;
        
        return new Promise(resolve => { localResolve = resolve });

    }

    const handleResponse = (value: any) => 
    {
        
        localResolve(value);
        _visible.value = false;

    }

    return {
        handleResponse,
        _fieldsHeaders,
        _fieldsNames,
        _values,
        funcSelecionaOpcao,
        _visible,
        _title
    }

}

